// extracted by mini-css-extract-plugin
export var container = "_89-0";
export var icon = "_89-1";
export var text = "_89-2";